<template>
  <div ref="icons" style="display:flex;padding-top:20px;">
    <template v-for="(val,index) in icon">
      <Aicon :key="index" :url="icon[index].url" :src="icon[index].src" @on-click="handleClick(index)">
        <a style="text-decoration:none;">{{icon[index].name}}</a>
      </Aicon>
      <div v-show="index!==(icon.length-1)" class="horizontal-line" :key="icon[index].name"></div>
    </template>
  </div>
</template>

<script>
import Aicon from '@/components/Alayout/Aicon/Aicon'
export default {
  name : 'Aicons',
  components: {
    Aicon
  },
  data(){
    return {
      icon:[
        {name:"总览",src:require("@/assets/Aicon/mbtn1.png"),url:"../../Aoverview"},
        {name:"能源",src:require("@/assets/Aicon/mbtn2.png"),url:'../../Energy'},
        {name:"异常",src:require("@/assets/Aicon/mbtn3.png"),url:'../../Exceptions'}
      ]
    }
  },
  methods:{
    handleClick(e){
      let fa = this.$refs.icons;
      let ch = fa.getElementsByClassName("iconSelected");
      if(ch.length !==0) ch[0].className = "icon";
      fa.getElementsByClassName("icon")[e].className = "icon iconSelected";
    }
  }
}
</script>

<style scoped>
  .horizontal-line{
    width: 2px;
    height: 75px;
    background: linear-gradient(rgb(242, 242, 242),rgba(133, 133, 133,0.5), rgba(85, 85, 85,0.5), rgba(133, 133, 133,0.5),rgb(242, 242, 242));
  }
  .layout{
    height: 100%;
    width: 100%;
    background: rgb(242, 242, 242)
  }
</style>


// WEBPACK FOOTER //
// src/components/Alayout/Aicon/Aicons.vue